import { Utils } from "@/plugins/utils"
import router from "@/router"

export default {
	namespaced: true,
	state: {
		lstCfc: [],
		cfc: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {},
	mutations: {
		set(state, cfc) {
			state.cfc = cfc
			if (cfc)
				state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.cfc = null
		},
		setParamsDataTable(state, payload) {
			state.lstCfc = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		}
	},
	actions: {
		initForm(store) {
			store.commit("initForm")
		},
		async find(store, { cfccliente, cfcagente }) {
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios
				.get(`/Customer/PreferredBearer/Find/${cfccliente}/${cfcagente}`)
				.then(response => {
					let cfc = Utils.ValidateAxiosResponse(response.data)
					store.commit("set", cfc)
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
				})
			store.state.loading = false
		},
		save(store) {
			if (store.state.update) {
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true }
			)
			await this._vm.$axios
				.post("/Customer/PreferredBearer/Insert", store.state.cfc)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/portadores-preferenciais")
					store.state.cfc = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async update(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true }
			)
			await this._vm.$axios
				.put("/Customer/PreferredBearer/Update", store.state.cfc)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/portadores-preferenciais")
					store.state.cfc = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async delete(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true }
			)
			await this._vm.$axios
			.delete(`/Customer/PreferredBearer/Delete/${store.state.cfc.cfccliente}/${store.state.cfc.cfcagente}`)
			.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/portadores-preferenciais")
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async findList(store) {
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios
				.get("/Customer/PreferredBearer/FindList")
				.then(response => {
					let lstCfc = Utils.ValidateAxiosResponse(response.data)
					store.state.lstCfc = lstCfc
					store.state.hasNext = lstCfc.length > store.state.itemsPerPage
				})
				.catch(error => {
					store.state.lstCfc = []
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1 }) {
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios
				.get(`/Customer/PreferredBearer/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					store.commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					store.state.lstCfc = []
					store.state.search = ""
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.state.loading = false
			return payload
		}
	}
}
